@let label = labelSg();
@let value = displayValueSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label"> {{ label }} </span>
  }
  <div (click)="openDateRangePickerHandler(overlay.picker)">
    <atn-ds-date-range-input
      [rangePicker]="overlay.picker"
      [value]="value"
    />
    <atn-ds-date-range-overlay
      #overlay
      (apply)="applyChangesHandler()"
      (cancel)="discardChangesHandler()"
    />
  </div>
</div>
